import React, { Component } from "react";
import * as LINK from "./../../constants/Links";

import { connect } from "react-redux";
import { Container, Row, Col } from "react-bootstrap";
import { Route, Switch, Link, Redirect } from "react-router-dom";

import * as Actions from "./../../actions/index";

class Index extends Component
{
  constructor(props)
  {
    super(props);
    this.state = {

    };

  }
  // static getDerivedStateFromProps(nextProps, prevState)
  // {


  // }

  componentDidUpdate(prevProps, prevState)
  {


  }
  componentDidMount()
  {

  }
  render()
  {
    let { routers } = this.props;

    return (
      <div className="container p-6 launchpad-page">
        <div className="launchpad-title">
          <h1 className="pb-6">Create New Airdrop</h1>
        </div>
        <div>
          <div className="ant-card ant-card-bordered">
            <div className="ant-card-body">
              <form>
                <p className="has-text-primary is-size-7">(*) is required field.</p>
                <div className="field">
                  <div className="is-flex is-align-items-center mb-2 flex-wrap">
                    <div className="is-flex-grow-1 mr-4"><label className="label" for="tokenAddress">Token address<sup
                      className="has-text-danger">*</sup></label></div>
                  </div>
                  <div className="control"><input className="input" type="text" placeholder="Ex: PinkMoon" id="tokenAddress" name="tokenAddress" autocomplete="off" value="" />
                    <p className="help is-info">Create airdrop fee: 0.5 BNB</p>
                  </div>
                </div>
                <div className="has-text-centered"><button type="button" className="ant-btn ant-btn-primary" disabled=""><span>Next</span></button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state) =>
{
  return {

  };
};
const mapDispatchToProps = (dispatch, props) =>
{
  return {
    // GetConvertion: (idpage) =>
    // {
    //   dispatch(Actions.GetConvertionRequest(idpage));
    // },
    // Getprovince: () =>
    // {
    //   dispatch(Actions.GetprovinceRequest());
    // },
    // GetComment: (idpage) =>
    // {
    //   dispatch(Actions.GetCommentRequest(idpage));
    // },
    // GetPageList: (data) =>
    // {
    //   dispatch(Actions.GetPageListRequest(data));
    // },
    // SetPageLocal: (data) =>
    // {
    //   dispatch(Actions.SetPageLocal(data));
    // },
    // GetSetting: () =>
    // {
    //   dispatch(Actions.GetSettingRequest());
    // },
    // GetSuportReply: () =>
    // {
    //   dispatch(Actions.GetSuportReplyRequest());
    // },
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Index);
